'use client';

import { Banner } from '@curology/ui-components-web/react/Banner';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React from 'react';

import Confetti from '@/components/confetti';
import { type InformationStep } from '@/services/funnelService/models/informationStep';

import freeGifts from './content/images/product-free-gifts.png';
import { BackButton } from '../../components/ProgressButton/BackButton';
import { NextButton } from '../../components/ProgressButton/NextButton';

export const Information = ({ step }: { step: InformationStep }) => {
  const {
    confetti = false,
    contentfulImageUrl,
    showImageFirst = false,
    image,
    title,
    description,
    nextBtnText = 'Next',
    backBtn = true,
    backBtnText = 'Back',
    callout,
    footnote,
  } = step;

  const titleAndDescription = (
    <>
      <Typography className="cur-leading-9" size="h2">
        {title}
      </Typography>
      {description && (
        <Typography size="body" className="cur-leading-relaxed">
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        </Typography>
      )}
    </>
  );

  return (
    <section className="cur-text-primary">
      {callout && (
        <Banner className="!cur-bg-surface-brand">
          <Typography weight="normal" size="body" className="cur-my-1">
            {callout}
          </Typography>
        </Banner>
      )}
      <div className="cur-px-4 cur-py-8 cur-mx-auto">
        <div className="cur-max-w-sm cur-my-0 cur-mx-auto cur-relative cur-flex cur-flex-col cur-gap-6">
          {confetti && (
            <Confetti
              options={{
                isInfinite: true,
                numParticles: 20,
                speedRange: [1, 4],
              }}
              className="!cur-h-auto -cur-left-8 -cur-right-8 -cur-top-6 cur-w-full md:cur-w-[calc(100%+4rem)]"
            />
          )}
          {!showImageFirst && titleAndDescription}
          <div className="cur-mx-auto">
            {image || contentfulImageUrl ? (
              <Image
                priority
                // @ts-expect-error - TODO: broken by strictNullChecks
                src={image ? image.src : contentfulImageUrl}
                alt={image ? image.alt : 'Hero image'}
                quality={100}
                width={375}
                height={275}
                className="cur-mx-auto"
              />
            ) : (
              <Image
                priority
                src={freeGifts}
                alt="30 day trial - free gifts"
                quality={100}
                className="cur-w-[260px] cur-mx-auto"
              />
            )}
          </div>
          {showImageFirst && titleAndDescription}
          <div className="cur-flex cur-flex-col cur-gap-y-2">
            <NextButton>{nextBtnText}</NextButton>
            {backBtn && <BackButton>{backBtnText}</BackButton>}
          </div>
          {footnote && (
            <Typography
              size="meta"
              className="cur-text-center cur-max-w-[328px] cur-mx-auto"
            >
              {footnote}
            </Typography>
          )}
        </div>
      </div>
    </section>
  );
};
